/* ==========================================================================
   Olfatto v2 — scroll suavizado (Lenis)

   Versión FIJADA, no rango: un rango deja que la librería cambie sola.

   Reglas que implementa:
   · No se instancia bajo 1024px. La inercia nativa de iOS/Android está
     mejor calibrada que cualquier reimplementación.
   · Respeta prefers-reduced-motion: si está activo, no arranca.
   · Un solo loop de requestAnimationFrame. Si otro efecto necesita rAF,
     se engancha acá — nunca un segundo loop.
   · Se detiene con los drawers de Dawn. En vez de parchear archivos de
     Dawn, observa la clase que Dawn ya pone en <body> al abrir el cart
     drawer, el menú o cualquier modal (overflow-hidden*). Así cubre todos
     los casos, presentes y futuros, sin tocar su código.
   · Si el import del CDN falla, la página funciona con scroll nativo.
     El scroll suavizado es mejora, no requisito.
   ========================================================================== */

const MIN_WIDTH = 1024;

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const narrow = window.matchMedia(`(max-width: ${MIN_WIDTH - 1}px)`).matches;
const coarse = window.matchMedia('(pointer: coarse)').matches;

if (!reduced && !narrow && !coarse) {
  try {
    const { default: Lenis } = await import(
      'https://cdn.jsdelivr.net/npm/lenis@1.3.26/+esm'
    );

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      syncTouch: false,
      touchMultiplier: 0
    });

    /* loop único */
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    window.olfLenis = lenis;

    /* Dawn marca <body> con overflow-hidden* mientras hay un overlay
       abierto. Es la señal más fiable y no requiere tocar sus archivos. */
    const isLocked = () =>
      Array.from(document.body.classList).some((c) =>
        c.startsWith('overflow-hidden')
      );

    let locked = isLocked();
    if (locked) lenis.stop();

    new MutationObserver(() => {
      const now = isLocked();
      if (now === locked) return;
      locked = now;
      if (now) lenis.stop();
      else lenis.start();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    /* el propio menú móvil usa <details>; por si se abre en un desktop
       estrecho, se trata igual que un overlay */
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement)) return;
      if (!d.classList.contains('olf-header__m')) return;
      if (d.open) lenis.stop();
      else if (!isLocked()) lenis.start();
    }, true);

    /* enlaces ancla dentro de la página */
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -88 });
    });
  } catch (err) {
    /* sin scroll suavizado; todo lo demás sigue funcionando */
    console.warn('[olfatto] Lenis no cargó, se usa scroll nativo.', err);
  }
}
